import React from 'react'
import type { EducationLevelProps } from '@/features/enrollment'

export default function EducationLevel({ enrollmentData, updateEnrollmentData, errors, injuredPartyDOB, originalEducationLevel, educationLevelAutoSelected, setEducationLevelAutoSelected }: EducationLevelProps) {
  return (
    <div>
      <label className="block text-sm font-medium text-accent-900 mb-2">
        Highest Level of Education for Gamer? <span className="text-red-500">*</span>
      </label>
      
      {/* Auto-selection indicator - only show if value matches original auto-selected value */}
      {enrollmentData.highestEducationLevel && injuredPartyDOB && enrollmentData.highestEducationLevel === originalEducationLevel && (
        <div className="mb-3 p-3 bg-blue-50 border border-blue-200 rounded-lg">
          <p className="text-sm text-blue-800">
            <span className="font-medium">Auto-selected based on age:</span>
            <span className="ml-2 text-blue-600 font-semibold">
              {enrollmentData.highestEducationLevel}
            </span>
          </p>
          <p className="text-xs text-blue-600 mt-1">
            You can change this selection using the dropdown below if needed.
          </p>
        </div>
      )}
      
      <select 
        name="highestEducationLevel"
        className={`input-field w-full ${errors.highestEducationLevel ? 'border-red-500' : ''} ${enrollmentData.highestEducationLevel && injuredPartyDOB && enrollmentData.highestEducationLevel === originalEducationLevel ? 'border-blue-300 bg-blue-50' : 'bg-white'}`} 
        value={enrollmentData.highestEducationLevel || ''} 
        onChange={(e) => {
          updateEnrollmentData('highestEducationLevel', e.target.value)
          // Prevent auto-selection from interfering with user changes
          if (!educationLevelAutoSelected) {
            setEducationLevelAutoSelected(true)
          }
        }}
      >
        <option value="">Select Education Level</option>
        <option value="Elementary/Junior High School">Elementary/Junior High School</option>
        <option value="High School">High School</option>
        <option value="Vocational School">Vocational School</option>
        <option value="College/University">College/University</option>
        <option value="Graduate School">Graduate School</option>
      </select>
      {errors.highestEducationLevel && (
        <p className="mt-1 text-sm text-red-600">{errors.highestEducationLevel}</p>
      )}
    </div>
  )
}